// import { colors, space, radius, fontSize } from "../../design/tokens";

// export default function Select({ children, style, ...props  }) {
//   return (
//     <select
//       style={{
//         width: "100%",

//         background: colors.surface,

//         border: "none",
//         borderBottom: "",
//         outline: "none",

//         borderRadius: radius.xl,

//         padding: space.lg,

//         fontSize: fontSize.md,
//         color: colors.text,

//         ...style,
//       }}
//       {...props}
//     >
//         {children}
//     </select>
//   );
// }

// components/forms/Select.jsx

import { useState } from "react";

import {
  colors,
  space,
  radius,
  fontSize,
  shadows,
  borders,
} from "../../design/tokens";

export default function Select({
  value,
  options = [],
  placeholder = "Select",
  onChange,
  style,
}) {
  const [open, setOpen] = useState(false);

  const selected = options.find(
    option => option.value === value
  );

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
      }}
    >
      {/* Trigger */}

      <button
        onClick={() => setOpen(!open)}
        style={{
          width: "100%",

          background: colors.surfaceSoft,

          border: borders.sm,
          borderColor: colors.primary,

          borderRadius: radius.xl,

          padding: space.lg,

          fontSize: fontSize.md,
          color: colors.text,

          textAlign: "left",

          cursor: "pointer",

          boxShadow: shadows.sm,

          ...style,
        }}
      >
        {selected?.label || placeholder}
      </button>

      {/* Dropdown */}

      {open && (
        <div
          style={{
            position: "absolute",

            top: "calc(100% + 8px)",
            left: 0,
            right: 0,

            background: colors.surface,

            borderRadius: radius.xl,

            overflow: "hidden",

            boxShadow: shadows.md,

            zIndex: 100,
          }}
        >
          {options.map(option => (
            <button
              key={option.value}
              onClick={() => {
                onChange(option.value);
                setOpen(false);
              }}
              style={{
                width: "100%",

                background: "transparent",

                border: "none",

                padding: space.lg,

                textAlign: "left",

                cursor: "pointer",

                fontSize: fontSize.md,

                color: colors.text,
              }}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}